import React, { useEffect, useState, useRef } from 'react';
import './NetflixTitle.css';
import netflixSound from './netflix-sound.mp3';
import { useNavigate } from 'react-router-dom';
import logoImage from '../src/images/logo-2.png'; // Update with the path to your logo

const NetflixTitle = () => {
  const [isPulsing, setIsPulsing] = useState(false);
  const [isZooming, setIsZooming] = useState(false);
  const audioRef = useRef<HTMLAudioElement | null>(null);
  const navigate = useNavigate();

  // Initialize audio on component mount
  useEffect(() => {
    const audioElement = new Audio(netflixSound);
    audioElement.preload = 'auto';
    audioElement.load();
    audioRef.current = audioElement;
    
    // Start pulsing animation after a short delay
    const timer = setTimeout(() => {
      setIsPulsing(true);
    }, 1000);

    return () => {
      clearTimeout(timer);
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current = null;
      }
    };
  }, []);

  const handleEnter = () => {
    if (!audioRef.current || isZooming) return;

    // Start zoom animation immediately
    setIsZooming(true);

    // Delay sound by 2 seconds
    setTimeout(() => {
      if (audioRef.current) {
        audioRef.current.volume = 1.0;
        audioRef.current.play()
          .then(() => {
            console.log('Sound playing successfully');
          })
          .catch(error => {
            console.error('Audio play error:', error);
          });
      }
    }, 1500);

    // Navigate after animation completes
    setTimeout(() => {
      navigate('/browse');
    }, 5500); // Increased to account for sound delay
  };

  return (
    <div 
      className="netflix-container" 
      onClick={handleEnter}
    >
      <img
        src={logoImage}
        alt="Uchenna Anyaoha - MLOps Expert and AI Business Solutions Architect Portfolio"
        className={`netflix-logo ${isPulsing ? 'pulse' : ''} ${isZooming ? 'zoom' : ''}`}
      />
      {isPulsing && !isZooming && (
        <div className="enter-prompt">
          Click to Enter
        </div>
      )}
    </div>
  );
};

export default NetflixTitle;
